import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * Consistent header for every waste submission stepper step — an `h5` title
 * (matching the Overview's "Submission Overview") and an optional description.
 * Keeps section headers uniform across steps that embed reused profile sections
 * (which carry their own sub-headers).
 */
export function StepHeader({ title, description }: { title: string; description?: ReactNode }) {
  return (
    <Box>
      <Typography variant="h5">{title}</Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
